import axios from 'axios';

const API_BASE = '/wp-json/verenza-ai/v1/configurator';

export async function fetchConfiguratorSchema() {
    const response = await axios.get(`${API_BASE}/schema`);
    return response?.data?.schema || null;
}

export async function fetchConfiguratorRecommendations(payload) {
    const response = await axios.post(`${API_BASE}/recommendations`, payload || {});
    return response?.data?.data || null;
}

export async function applyConfiguratorToShop(payload) {
    const response = await axios.post(`${API_BASE}/apply`, payload || {});
    return response?.data?.data || null;
}

export async function fetchConfiguratorState(token = '') {
    const params = token ? { token } : {};
    const response = await axios.get(`${API_BASE}/state`, { params });
    return response?.data?.data || null;
}
